var u = Object.defineProperty;
var o = (r, e, t) => e in r ? u(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => o(r, typeof e != "symbol" ? e + "" : e, t);
class y {
  constructor(e) {
    s(this, "route");
    s(this, "query");
    Object.assign(this, {
      route: e.route ?? "",
      query: e.query ?? ""
    });
  }
}
export {
  y as LastSearchesEntryDTO
};
